export const WAMP_JWT_ERROR = 'wamp.error.jwt_error';
